var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#DD353F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.195 16.632c0 1.652 1.604 2.759 3.57 2.759 1.965 0 3.787-1.107 3.787-2.759 0-1.65-1.822-3.217-3.787-3.217-1.966 0-3.56-1.34-3.56-2.99 0-1.65 1.594-2.988 3.56-2.988 1.965 0 3.787 1.108 3.787 2.758M13.874 6.517V20.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.747 13.874c0 7.11-5.764 12.873-12.873 12.873C6.764 26.747 1 20.983 1 13.874 1 6.764 6.764 1 13.874 1s12.873 5.764 12.873 12.874z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyOCIgaGVpZ2h0PSIyOCIgdmlld0JveD0iMCAwIDI4IDI4Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlPSIjREQzNTNGIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiPgogICAgICAgIDxwYXRoIGQ9Ik0xMC4xOTUgMTYuNjMyYzAgMS42NTIgMS42MDQgMi43NTkgMy41NyAyLjc1OSAxLjk2NSAwIDMuNzg3LTEuMTA3IDMuNzg3LTIuNzU5IDAtMS42NS0xLjgyMi0zLjIxNy0zLjc4Ny0zLjIxNy0xLjk2NiAwLTMuNTYtMS4zNC0zLjU2LTIuOTkgMC0xLjY1IDEuNTk0LTIuOTg4IDMuNTYtMi45ODggMS45NjUgMCAzLjc4NyAxLjEwOCAzLjc4NyAyLjc1OE0xMy44NzQgNi41MTdWMjAuMzEiLz4KICAgICAgICA8cGF0aCBkPSJNMjYuNzQ3IDEzLjg3NGMwIDcuMTEtNS43NjQgMTIuODczLTEyLjg3MyAxMi44NzNDNi43NjQgMjYuNzQ3IDEgMjAuOTgzIDEgMTMuODc0IDEgNi43NjQgNi43NjQgMSAxMy44NzQgMXMxMi44NzMgNS43NjQgMTIuODczIDEyLjg3NHoiLz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };